import React, { useEffect, useState } from "react";
import { APIURL } from "../Config";
import axios from "axios";
import LoanDetails from "./LoanDetails";
import { DownloadTableExcel } from "react-export-table-to-excel";
import moment from "moment";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";

function RegisterEmployerDetails({
  emailid,
  rejectedReason,
  apiKey,
  activeTab2,
  cid,
}) {
  const tableRegisterEmployerRejected = React.useRef(null);
  const token = localStorage.getItem("token");
  const email = localStorage.getItem("emailId");
  const tableRegisterEmployer = React.useRef(null);
  const [lid, setLid] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [empDetails, setEmpDetails] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [total, setTotal] = useState({
    totalAmtdisbursed: 0,
    totallimitassigned: 0,
    totaloutstandingamt: 0,
  });
  const [getlimitExtend, setGetLimitExtend] = useState("");
  const [limitExtend, setLimitExtend] = useState("");

  useEffect(() => {
    getEmployeeDetails(emailid, apiKey);
  }, []);
  console.log("keyyy: ", apiKey, rejectedReason, emailid);

  // const limitExtendChange = (e) => {
  //   setLimitExtend(e.target.value);
  // };
  // const handleSubmit = (limitExtend) => {
  //   console.log("getlimitExtend::: ", getlimitExtend);
  //   if (getlimitExtend.limitAssign > limitExtend) {
  //     toast.warning("Invalid limit extend...");
  //   } else {
  //     const data = {
  //       emailid: emailid,
  //       mobile: getlimitExtend.mobileNo,
  //       limitassigned: limitExtend,
  //     };
  //     axios
  //       .request(`${APIURL}/corporate/updatelimitassigned`, {
  //         method: "POST",
  //         data: data,
  //         headers: {
  //           Authentication: token,
  //           "Content-Type": "application/json",
  //         },
  //       })
  //       .then((response) => {
  //         console.log("response", response);
  //         setShowModal(false);
  //         // setManageEmpStatus(false);
  //         // setEmpSummaryStatus(true);
  //         toast.success("Limit extend successfully...");
  //       })
  //       .catch((error) => {
  //         console.log("error", error);
  //         toast.warning("Invalid...");
  //       });
  //   }
  // };

  const manageemployeesStatus = (mobile, status) => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/employerstatus`, {
        method: "POST",
        data: {
          ownerEmailId: emailid,
          ownerEmail: email,
          mobile: mobile,
          status: status,
        },
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        toast.success(response.data);
        getEmployeeDetails(emailid, apiKey);
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  const manageemployeesStatusPL = (mobile, status) => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/employerstatusPL`, {
        method: "POST",
        data: {
          ownerEmailId: emailid,
          ownerEmail: email,
          mobile: mobile,
          status: status,
        },
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        toast.success(response.data);
        getEmployeeDetails(emailid, apiKey);
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const getEmployeeDetails = (email, keys) => {
    let sAmount = [];
    let yAmount = [];

    let zAmount = [];

    setIsLoader(true);
    const url =
      keys == "alldata" || keys == "usedlimit" || keys == "unusedlimit"
        ? `${APIURL}/${keys}/${cid}`
        : `${APIURL}/links/${email}/${keys}`;
    axios(url, {
      method: "GET",
      headers: {
        Authentication: token,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        let finalArray = [];
        setIsLoader(false);
        console.log("finalArray", finalArray);
        let data = [];
        // if (activeTab2 == "use") {
        //   data = response.data.filter((row) => Number(row.limitused) > 0);
        // } else if (activeTab2 == "unuse") {
        //   data = response.data.filter(
        //     (row) =>
        //       Number(row.limitused) === 0 && Number(row.limitassigned) > 0
        //   );
        // } else {
        //   data = response.data;
        // }

        setEmpDetails(response.data);

        data.map((row, index) => {
          sAmount.push(row.amtdisb);
          yAmount.push(Number(row.limitassigned));
          zAmount.push(row.outstandingamt);
        });
        const total0 = sAmount.reduce((a, b) => a + b, 0);
        console.log("total0::: ", total0);
        const total1 = yAmount.reduce((c, d) => c + d, 0);
        console.log("total1::: ", total1);
        const total2 = zAmount.reduce((e, f) => e + f, 0);
        console.log("total2::: ", total2);
        setTotal({
          totalAmtdisbursed: total0.toFixed(2),
          totallimitassigned: total1.toFixed(2),
          totaloutstandingamt: total2.toFixed(2),
        });
      })

      .catch((error) => {
        setIsLoader(false);
        console.log("----", error);
      });
  };
  return (
    <div>
      {showSearch ? (
        <>
          <div className="p-3 d-flex justify-content-start mt-3">
            <button
              className="btn btn-secondary"
              style={{ width: "100px" }}
              onClick={() => {
                setShowSearch(false);
              }}
            >
              Back
            </button>
          </div>
          <div className="p-3 pt-2">
            <LoanDetails lid={lid} />
          </div>
        </>
      ) : (
        <>
          {apiKey == "limitutilized" ? (
            <div className="table-responsive mt-3">
              <div className="mx-0 d-flex flex-column flex-md-row align-items-center justify-content-end">
                <div className="mb-2 flex-grow-1">
                  <DownloadTableExcel
                    filename="RegisteredEmployerRejected"
                    sheet="users"
                    currentTableRef={tableRegisterEmployerRejected.current}
                  >
                    <button
                      className="btn btn-success mb-3 mb-md-0"
                      style={{
                        width: "120px",
                        backgroundColor: "#66a725",
                      }}
                    >
                      Download
                    </button>
                  </DownloadTableExcel>
                </div>
                <div>
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center mb-2">
                    <p className="mx-md-2 mb-1 mb-md-0 font-weight-bold">
                      Total Today Disbursed: {empDetails[0]?.totaldisb}
                    </p>
                    <p className="mx-md-2 mb-1 mb-md-0 font-weight-bold">
                      Total Disbursed month: {empDetails[0]?.totaldisbmonth}
                    </p>
                  </div>
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center mb-2">
                    <p className="mx-md-2 mb-1 mb-md-0 font-weight-bold">
                      Total Amount Disbursed: {total?.totalAmtdisbursed}
                      {console.log("total:::---- ", total)}
                    </p>
                    <p className="mx-md-2 mb-1 mb-md-0 font-weight-bold">
                      Total Limit Assigned: {total?.totallimitassigned}
                    </p>
                    <p className="mx-md-2 mb-1 mb-md-0 font-weight-bold">
                      Total Outstanding Amount: {total?.totaloutstandingamt}
                    </p>
                  </div>
                </div>
              </div>
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}>Sr. No</th>
                    <th style={{ textAlign: "center" }}>Dt. & time</th>
                    <th style={{ textAlign: "center" }}>Employee name </th>
                    <th style={{ textAlign: "center" }}>Employer name</th>

                    <th style={{ textAlign: "center" }}>Mobile</th>
                    <th style={{ textAlign: "center" }}>LID</th>

                    <th style={{ textAlign: "center" }}>Limit assigned</th>
                    <th style={{ textAlign: "center" }}>Amt withdrawal</th>
                    <th style={{ textAlign: "center" }}>
                      One time set up fees
                    </th>
                    <th style={{ textAlign: "center" }}>Convenience fees</th>
                    <th style={{ textAlign: "center" }}>Late Fee</th>
                    <th style={{ textAlign: "center" }}>Repayment amount</th>
                    <th style={{ textAlign: "center" }}>Outstanding amount</th>

                    <th style={{ textAlign: "center" }}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {empDetails &&
                    empDetails.map((details, index) => (
                      <tr key={index}>
                        <td style={{ textAlign: "center" }}>{index + 1}</td>
                        <td>
                          {details.dttime
                            ? moment(details.dttime).format(
                                "DD-MM-YYYY, h:mm:ss A"
                              )
                            : ""}
                        </td>
                        <td>{details.empname}</td>
                        <td>{details.employername}</td>
                        <td style={{ textAlign: "center" }}>
                          {details.mobile}
                        </td>
                        <td
                          style={{
                            color: "blue",
                            cursor: "pointer",
                            textAlign: "center",
                          }}
                          onClick={() => {
                            if (details.lid) {
                              setLid(details.lid);
                              setShowSearch(true);
                            }
                          }}
                        >
                          {details.lid}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {details.limitassigned}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {details.amtdisb}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {details?.onetimesetup}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {details.convfees}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {details?.lateFee}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {details.repayamt}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {details.outstandingamt}
                        </td>
                        <td style={{ width: "120px" }}>
                          <div className="d-flex">
                            <button
                              className={`btn ${
                                details?.status === "ACTIVE"
                                  ? "btn-success"
                                  : "btn-outline-success"
                              }`}
                              onClick={() =>
                                manageemployeesStatus(details.mobile, "ACTIVE")
                              }
                              disabled={details?.status === "ACTIVE"}
                            >
                              Active
                            </button>
                            <button
                              className={`btn ml-2 ${
                                details?.status === "INACTIVE"
                                  ? "btn-danger"
                                  : "btn-outline-danger"
                              }`}
                              onClick={() =>
                                manageemployeesStatus(
                                  details.mobile,
                                  "INACTIVE"
                                )
                              }
                              disabled={details?.status === "INACTIVE"}
                            >
                              Inactive
                            </button>
                          </div>
                        </td>{" "}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="table-responsive mt-3">
              <div className="mb-2">
                <DownloadTableExcel
                  filename="RegisteredEmployer"
                  sheet="users"
                  currentTableRef={tableRegisterEmployer.current}
                >
                  <button
                    className="btn btn-success mb-3 mb-md-0"
                    style={{
                      width: "120px",
                      backgroundColor: "#66a725",
                    }}
                  >
                    Download
                  </button>
                </DownloadTableExcel>
              </div>
              {isLoader ? (
                <div className="d-flex justify-content-center">
                  <div className="spinner-border text-success" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : (
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th style={{ textAlign: "center" }}>Sr. No</th>
                      <th style={{ textAlign: "center" }}>Name</th>
                      <th style={{ textAlign: "center" }}>LID </th>
                      <th style={{ textAlign: "center" }}>Mobile</th>
                      <th style={{ textAlign: "center" }}>Limit assigned</th>

                      <th style={{ textAlign: "center" }}>Limit used</th>
                      {rejectedReason && (
                        <th style={{ textAlign: "center" }}>Remark</th>
                      )}
                      {/* {apiKey == "employeedetails" && (
                        <th style={{ textAlign: "center" }}>Extend</th>
                      )} */}
                      {!rejectedReason && (
                        <>
                          <th style={{ textAlign: "center" }}>Status</th>
                          <th style={{ textAlign: "center" }}>
                            Status Personal Loan
                          </th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {empDetails &&
                      empDetails.map((detail, index) => (
                        <tr key={index}>
                          <td style={{ textAlign: "center" }}>{index + 1}</td>
                          <td style={{ textAlign: "center" }}>{detail.name}</td>
                          <td
                            style={{
                              textAlign: "center",
                              color: "blue",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              if (detail.lid) {
                                setLid(detail.lid);
                                setShowSearch(true);
                              }
                            }}
                          >
                            {detail.lid}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {detail.mobile}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {detail.limitassigned}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {detail.limitused}
                          </td>
                          {rejectedReason && (
                            <td style={{ textAlign: "center" }}>
                              {detail.remark}
                            </td>
                          )}
                          {/* {apiKey == "employeedetails" && (
                            <td style={{ textAlign: "center" }}>
                              <button
                                className="btn btn-success"
                                style={{ width: "100px" }}
                                onClick={() => {
                                  setShowModal(true);
                                  setLimitExtend(detail.limitAssign);
                                  setGetLimitExtend(detail);
                                }}
                              >
                                Extend
                              </button>
                            </td>
                          )} */}
                          {!rejectedReason && (
                            <>
                              <td style={{ width: "120px" }}>
                                <div className="d-flex">
                                  <button
                                    style={{
                                      backgroundColor:
                                        detail?.status === "ACTIVE"
                                          ? "#28a745"
                                          : "#f8f9fa",
                                      color:
                                        detail?.status === "ACTIVE"
                                          ? "white"
                                          : "#6c757d",
                                      border: "1px solid #ced4da",
                                      padding: "0.375rem 0.75rem",
                                      borderRadius: "0.25rem",
                                      cursor:
                                        detail?.status === "ACTIVE"
                                          ? "not-allowed"
                                          : "pointer",
                                      transition: "all 0.2s ease",
                                      marginRight: "0.5rem",
                                    }}
                                    onMouseOver={(e) => {
                                      if (detail?.status !== "ACTIVE") {
                                        e.target.style.backgroundColor =
                                          "#28a745";
                                        e.target.style.color = "white";
                                      }
                                    }}
                                    onMouseOut={(e) => {
                                      if (detail?.status !== "ACTIVE") {
                                        e.target.style.backgroundColor =
                                          "#f8f9fa";
                                        e.target.style.color = "#6c757d";
                                      }
                                    }}
                                    onClick={() =>
                                      manageemployeesStatus(
                                        detail.mobile,
                                        "ACTIVE"
                                      )
                                    }
                                    disabled={detail?.status === "ACTIVE"}
                                  >
                                    Active
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor:
                                        detail?.status === "INACTIVE"
                                          ? "#dc3545"
                                          : "#f8f9fa",
                                      color:
                                        detail?.status === "INACTIVE"
                                          ? "white"
                                          : "#6c757d",
                                      border: "1px solid #ced4da",
                                      padding: "0.375rem 0.75rem",
                                      borderRadius: "0.25rem",
                                      cursor:
                                        detail?.status === "INACTIVE"
                                          ? "not-allowed"
                                          : "pointer",
                                      transition: "all 0.2s ease",
                                    }}
                                    onMouseOver={(e) => {
                                      if (detail?.status !== "INACTIVE") {
                                        e.target.style.backgroundColor =
                                          "#dc3545";
                                        e.target.style.color = "white";
                                      }
                                    }}
                                    onMouseOut={(e) => {
                                      if (detail?.status !== "INACTIVE") {
                                        e.target.style.backgroundColor =
                                          "#f8f9fa";
                                        e.target.style.color = "#6c757d";
                                      }
                                    }}
                                    onClick={() =>
                                      manageemployeesStatus(
                                        detail.mobile,
                                        "INACTIVE"
                                      )
                                    }
                                    disabled={detail?.status === "INACTIVE"}
                                  >
                                    Inactive
                                  </button>
                                </div>
                              </td>
                              <td style={{ width: "120px" }}>
                                <div className="d-flex">
                                  <button
                                    style={{
                                      backgroundColor:
                                        detail?.statusPL === "ACTIVE"
                                          ? "#28a745"
                                          : "#f8f9fa",
                                      color:
                                        detail?.statusPL === "ACTIVE"
                                          ? "white"
                                          : "#6c757d",
                                      border: "1px solid #ced4da",
                                      padding: "0.375rem 0.75rem",
                                      borderRadius: "0.25rem",
                                      cursor:
                                        detail?.statusPL === "ACTIVE"
                                          ? "not-allowed"
                                          : "pointer",
                                      transition: "all 0.2s ease",
                                      marginRight: "0.5rem",
                                    }}
                                    onMouseOver={(e) => {
                                      if (detail?.statusPL !== "ACTIVE") {
                                        e.target.style.backgroundColor =
                                          "#28a745";
                                        e.target.style.color = "white";
                                      }
                                    }}
                                    onMouseOut={(e) => {
                                      if (detail?.statusPL !== "ACTIVE") {
                                        e.target.style.backgroundColor =
                                          "#f8f9fa";
                                        e.target.style.color = "#6c757d";
                                      }
                                    }}
                                    onClick={() =>
                                      manageemployeesStatusPL(
                                        detail.mobile,
                                        "ACTIVE"
                                      )
                                    }
                                    disabled={detail?.statusPL === "ACTIVE"}
                                  >
                                    Active
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor:
                                        detail?.statusPL === "INACTIVE"
                                          ? "#dc3545"
                                          : "#f8f9fa",
                                      color:
                                        detail?.statusPL === "INACTIVE"
                                          ? "white"
                                          : "#6c757d",
                                      border: "1px solid #ced4da",
                                      padding: "0.375rem 0.75rem",
                                      borderRadius: "0.25rem",
                                      cursor:
                                        detail?.statusPL === "INACTIVE"
                                          ? "not-allowed"
                                          : "pointer",
                                      transition: "all 0.2s ease",
                                    }}
                                    onMouseOver={(e) => {
                                      if (detail?.statusPL !== "INACTIVE") {
                                        e.target.style.backgroundColor =
                                          "#dc3545";
                                        e.target.style.color = "white";
                                      }
                                    }}
                                    onMouseOut={(e) => {
                                      if (detail?.statusPL !== "INACTIVE") {
                                        e.target.style.backgroundColor =
                                          "#f8f9fa";
                                        e.target.style.color = "#6c757d";
                                      }
                                    }}
                                    onClick={() =>
                                      manageemployeesStatusPL(
                                        detail.mobile,
                                        "INACTIVE"
                                      )
                                    }
                                    disabled={detail?.statusPL === "INACTIVE"}
                                  >
                                    Inactive
                                  </button>
                                </div>
                              </td>
                            </>
                          )}
                        </tr>
                      ))}
                  </tbody>
                </table>
              )}
              {/* <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                style={{ background: "rgb(255 255 255 / 40%)" }}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Limit Extend</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <input
                    type="number"
                    value={limitExtend}
                    onChange={limitExtendChange}
                    style={{
                      width: "100%",
                      padding: "10px",
                      boxSizing: "border-box",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      marginTop: "10px",
                      fontSize: "18px",
                    }}
                  />
                  <div className="d-flex mt-3 justify-content-end">
                    <button
                      className="btn btn-secondary"
                      style={{ width: "100px" }}
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-success ml-2"
                      style={{
                        width: "100px",
                        background: "#66a725",
                      }}
                      onClick={() => handleSubmit(limitExtend)}
                    >
                      Submit
                    </button>
                  </div>
                </Modal.Body>
              </Modal> */}
            </div>
          )}
        </>
      )}
      <table
        className="table table-striped mt-3 "
        style={{ display: "none" }}
        ref={tableRegisterEmployerRejected}
      >
        <thead>
          <tr>
            <th style={{ textAlign: "center" }}>Sr. No</th>
            <th style={{ textAlign: "center" }}>Dt. & time</th>
            <th style={{ textAlign: "center" }}>Employee name </th>
            <th style={{ textAlign: "center" }}>Employer name</th>

            <th style={{ textAlign: "center" }}>Mobile</th>
            <th style={{ textAlign: "center" }}>LID</th>

            <th style={{ textAlign: "center" }}>Limit assigned</th>
            <th style={{ textAlign: "center" }}>Amt withdrawal</th>
            <th style={{ textAlign: "center" }}>One time set up fees</th>
            <th style={{ textAlign: "center" }}>Convenience fees</th>
            <th style={{ textAlign: "center" }}>Late Fee</th>
            <th style={{ textAlign: "center" }}>Repayment amount</th>
            <th style={{ textAlign: "center" }}>Outstanding amount</th>

            <th style={{ textAlign: "center" }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {empDetails &&
            empDetails.length > 0 &&
            empDetails.map((details, index) => (
              <tr key={index}>
                <td style={{ textAlign: "center" }}>{index + 1}</td>
                <td>
                  {details.dttime
                    ? moment(details.dttime).format("DD-MM-YYYY, h:mm:ss A")
                    : ""}
                </td>
                <td>{details.empname}</td>
                <td>{details.employername}</td>
                <td style={{ textAlign: "center" }}>{details.mobile}</td>
                <td
                  style={{
                    color: "blue",
                    cursor: "pointer",
                    textAlign: "center",
                  }}
                  onClick={() => {
                    if (details.lid) {
                      setLid(details.lid);
                      setShowSearch(true);
                    }
                  }}
                >
                  {details.lid}
                </td>
                <td style={{ textAlign: "center" }}>{details.limitassigned}</td>
                <td style={{ textAlign: "center" }}>{details.amtdisb}</td>
                <td style={{ textAlign: "center" }}>{details?.onetimesetup}</td>
                <td style={{ textAlign: "center" }}>{details.convfees}</td>
                <td style={{ textAlign: "center" }}>{details?.lateFee}</td>
                <td style={{ textAlign: "center" }}>{details.repayamt}</td>
                <td style={{ textAlign: "center" }}>
                  {details.outstandingamt}
                </td>
                <td style={{ width: "120px" }}>
                  <div className="d-flex">
                    <button
                      className={`btn ${
                        details?.status === "ACTIVE"
                          ? "btn-success"
                          : "btn-outline-success"
                      }`}
                      onClick={() =>
                        manageemployeesStatus(details.mobile, "ACTIVE")
                      }
                      disabled={details?.status === "ACTIVE"}
                    >
                      Active
                    </button>
                    <button
                      className={`btn ml-2 ${
                        details?.status === "INACTIVE"
                          ? "btn-danger"
                          : "btn-outline-danger"
                      }`}
                      onClick={() =>
                        manageemployeesStatus(details.mobile, "INACTIVE")
                      }
                      disabled={details?.status === "INACTIVE"}
                    >
                      Inactive
                    </button>
                  </div>
                </td>{" "}
              </tr>
            ))}
        </tbody>
      </table>

      <table
        className="table table-striped mt-3 "
        style={{ display: "none" }}
        ref={tableRegisterEmployer}
      >
        <thead>
          <tr>
            <th style={{ textAlign: "center" }}>Sr. No</th>
            <th style={{ textAlign: "center" }}>Name</th>
            <th style={{ textAlign: "center" }}>LID </th>
            <th style={{ textAlign: "center" }}>Mobile</th>
            <th style={{ textAlign: "center" }}>Limit assigned</th>
            <th style={{ textAlign: "center" }}>Limit used</th>
            {rejectedReason && <th style={{ textAlign: "center" }}>Remark</th>}
            <th style={{ textAlign: "center" }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {empDetails &&
            empDetails.length &&
            empDetails.map((detail, index) => (
              <tr key={index}>
                <td style={{ textAlign: "center" }}>{index + 1}</td>
                <td style={{ textAlign: "center" }}>{detail.name}</td>
                <td style={{ textAlign: "center" }}>{detail.lid}</td>
                <td style={{ textAlign: "center" }}>{detail.mobile}</td>
                <td style={{ textAlign: "center" }}>{detail.limitassigned}</td>
                <td style={{ textAlign: "center" }}>{detail.limitused}</td>
                {rejectedReason && (
                  <td style={{ textAlign: "center" }}>{detail.remark}</td>
                )}
                <td style={{ width: "120px" }}>{detail.status}</td>{" "}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}

export default RegisterEmployerDetails;
